// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FPFJ","top":"styles_top__1AhTj"};